import { RequestStatesTypes } from "types/RequestsStatesTypes";
import LoadingScreen from "./LoadingScreen";

/**
 * Custom props for the loading screen container
 */
interface Props {
    /**
     * The loading text for the loading screen
     */
    loadingText: string;
    /**
     * request status type to update the container
     */
    requestState: RequestStatesTypes;
    /**
     * A child component to render if successful
     */
    successComponent?: JSX.Element;
    /**
     * A child component to render if failure
     */
    failureComponent?: JSX.Element;
}

/**
 * A component that contains a loading screen and its replacement component if successful 
 */
export const LoadingScreenHandler = ({ loadingText, requestState, successComponent, failureComponent }: Props) => {

  /**
   * renders the loading screen container based on the request state
   */
  const renderComponent = () => {
    switch(requestState) {
      case "loading" : return (<LoadingScreen loadingText={loadingText} />);
      case "successful": return (<>{ successComponent }</>)
      case "failure": return (<>{ failureComponent }</>)
      default : return (<></>)
    }
  }

  return (
    renderComponent()
  )
}
